/**
 * V17.523 (Phase 1): the sidebar's own words, verbatim from the design (`Nav.dc.html` const S,
 * record 2026-10-25-050). Lao is the default. Search empty-state lines are the signed text (Rule 7).
 * V17.539 (2C): the slot's "Workspace: All · Phase 2" placeholder became the role control (`role`, `switchRole`).
 */
export const NAV_STRINGS = {
  lo: {
    nav: 'ເມນູຫຼັກ',
    brand: 'VTW Hub',
    role: 'ບົດບາດ',
    switchRole: 'ປ່ຽນບົດບາດ',
    search: 'ຄົ້ນຫາເມນູ',
    searchPh: 'ພິມຊື່ເມນູ ພາສາລາວ ຫຼື ອັງກິດ',
    menu: 'ໝວດເມນູ',
    collapseAll: 'ຫຍໍ້ທັງໝົດ',
    expandAll: 'ເປີດທັງໝົດ',
    close: 'ປິດ',
    closeMenu: 'ປິດເມນູ',
    signOut: 'ອອກຈາກລະບົບ',
    signOutAsk: 'ອອກຈາກລະບົບບໍ?',
    yes: 'ແມ່ນ',
    cancel: 'ຍົກເລີກ',
    dark: 'ໂໝດມືດ',
    light: 'ໂໝດແຈ້ງ',
    lang: 'ພາສາ',
    userMenu: 'ບັນຊີຜູ້ໃຊ້ ແລະ ບົດບາດ',
    collapse: 'ຫຍໍ້ເມນູ',
    expand: 'ຂະຫຍາຍເມນູ',
    more: (n: number) => `+${n}`,
    all: (n: number) => `ເມນູທັງໝົດທີ່ທ່ານເຂົ້າໄດ້ · ${n}`,
    found: (n: number) => `ພົບ ${n} ລາຍການ`,
    noRes: (q: string) => `ບໍ່ພົບເມນູທີ່ກົງກັບ “${q}”`,
    noResHint: 'ລອງພິມຊື່ເປັນພາສາລາວ ຫຼື ພາສາອັງກິດ',
    access: 'ຄົ້ນຫາໄດ້ສະເພາະໜ້າທີ່ທ່ານມີສິດເຂົ້າເຖິງ',
    kNav: 'ເລືອກ',
    kOpen: 'ເປີດ',
    kClose: 'ປິດ',
  },
  en: {
    nav: 'Main menu',
    brand: 'VTW Hub',
    role: 'Role',
    switchRole: 'Switch role',
    search: 'Search menu',
    searchPh: 'Type a menu name in Lao or English',
    menu: 'Sections',
    collapseAll: 'Collapse all',
    expandAll: 'Expand all',
    close: 'Close',
    closeMenu: 'Close menu',
    signOut: 'Sign out',
    signOutAsk: 'Sign out?',
    yes: 'Yes',
    cancel: 'Cancel',
    dark: 'Dark mode',
    light: 'Light mode',
    lang: 'Language',
    userMenu: 'Account and role',
    collapse: 'Collapse menu',
    expand: 'Expand menu',
    more: (n: number) => `+${n}`,
    all: (n: number) => `Everything you can open · ${n}`,
    found: (n: number) => `${n} found`,
    noRes: (q: string) => `No menu item matches “${q}”`,
    noResHint: 'Try the Lao or the English name',
    access: 'Search only finds pages you have access to',
    kNav: 'move',
    kOpen: 'open',
    kClose: 'close',
  },
} as const;

export type NavLang = keyof typeof NAV_STRINGS;
